import { v4 } from 'uuid';
import keyBy from 'lodash/keyBy';
import map from 'lodash/map';
import { OutputsByStepType } from 'xm-constants/toolStep';
import FormAlertIcon from 'resources/svg/form-alert.svg';

export const getMergeDefaults = () => ({
  name: 'Merge', // TODO: this needs to be translated, ditto for the integration steps
  id: 'FLOW_DESIGN_TOOL_MERGE',
  uuid: v4(),
  integrationType: 'MERGE',
  icon: '/static/images/icons/merge-step.svg',
  scriptStepType: 'TOOL', // an empty string will tell the Palette to not enable deletion
  isBuiltIn: true,
  builtInType: 'UTILITIES',
  descriptionId: 'FLOW_DESIGN_MERGE_STEP_DESCRIPTION',
  titleId: 'FLOW_DESIGN_MERGE_STEP_TITLE',
});

export const getSwitchDefaults = () => ({
  name: 'Switch', // TODO: this needs to be translated, ditto for the integration steps
  id: 'FLOW_DESIGN_TOOL_SWITCH',
  uuid: v4(),
  integrationType: 'SWITCH',
  icon: '/static/images/icons/switch-step.svg',
  scriptStepType: 'TOOL', // an empty string will tell the Palette to not enable deletion
  isBuiltIn: true,
  builtInType: 'UTILITIES',
  descriptionId: 'FLOW_DESIGN_SWITCH_STEP_DESCRIPTION',
});

export const getCreateEventDefaults = () => ({
  name: 'Create Alert Using a Form', // TODO: this needs to be translated, ditto for the integration steps
  id: 'FLOW_DESIGN_TOOL_CREATE_EVENT',
  uuid: v4(),
  integrationType: 'CREATE_EVENT',
  scriptStepType: 'TOOL', // an empty string will tell the Palette to not enable deletion
  icon: FormAlertIcon,
  isBuiltIn: true,
  builtInType: 'XMATTERS',
  descriptionId: 'FLOW_DESIGN_CREATE_EVENT_DESCRIPTION',
  testId: 'createEventStep',
});

export const getCreateAlertDefaults = () => ({
  name: 'Create Alert', // TODO: this needs to be translated, ditto for the integration steps
  id: 'FLOW_DESIGN_TOOL_CREATE_ALERT',
  uuid: v4(),
  integrationType: 'CREATE_ALERT',
  scriptStepType: 'TOOL', // an empty string will tell the Palette to not enable deletion
  icon: '/static/images/icons/alert.svg',
  isBuiltIn: true,
  builtInType: 'XMATTERS',
  descriptionId: 'FLOW_DESIGN_CREATE_ALERT_DESCRIPTION',
  testId: 'createAlertStep',
});

export const tools = [
  getMergeDefaults(),
  getSwitchDefaults(),
  getCreateEventDefaults(),
  getCreateAlertDefaults(),
];
export const toolsByType = keyBy(tools, 'integrationType');

export const getToolOutputs = stepType =>
  map(OutputsByStepType[stepType], item => ({
    ...item,
    descriptionId: item.descriptionId,
  }));
